import { Directive, HostListener, Input } from "@angular/core";

@Directive({
    selector: 'img[opOnErrorSrc]',
    standalone: true
})
export class OpOnErrorSrc {

    @Input('opOnErrorSrc') src: string;

    constructor() { }

    @HostListener('error', ['$event'])
    onError(e: ErrorEvent) {
        e.preventDefault();
        e.stopPropagation();
        const target = e.target as HTMLImageElement;
        if (target.src != this.src) {
            target.src = this.src
        }
    }
}
